import Carousel from "../components/carousel";

export default class TextColumnsSection {
  constructor(container) {

    this.element = container;
    var slideshowElement = this.element.querySelector('[data-flickity-config]');
    //console.log(slideshowElement)

    // If there is no image at all, there is nothing to init
    if (slideshowElement) {
      this.slideshow = new Carousel(slideshowElement);
    }
  }
}